import React from 'react';
import {
  Button,
  Link
} from '@one-thd/sui-atomic-components';
import { CreateAList } from '@thd-olt-component-react/list-forms';
import PropTypes from 'prop-types';

const CreateNewList = ({ variant }) => {

  const handleListCreation = (newList) => {
    // Trigger analytics event when list is successfully created
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('list-forms.create-without-products');
    }

    const id = newList?.id;
    if (id) {
      window.location.href = `/list/view/details/${id}`;
    }
  };

  const createNewListLink = ({ onClick }) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      href="#"
      onClick={(eve) => {
        eve.preventDefault();
        onClick();
      }}
    >
      Create New
    </Link>
  );

  const createNewListButton = ({ onClick }) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Button
      fullWidth
      href="#"
      onClick={(eve) => {
        eve.preventDefault();
        onClick();
      }}
    >
      Create New
    </Button>
  );

  return (
    <CreateAList
      CustomCreateListActionElement={variant === 'button' ? createNewListButton : createNewListLink}
      onCreate={handleListCreation}
    />
  );
};
CreateNewList.displayName = 'CreateNewList';
CreateNewList.propTypes = {
  variant: PropTypes.string
};
CreateNewList.defaultProps = {
  variant: 'link'
};
export default CreateNewList;
